/** A single result returned by the custom Retail Server SearchAddress operation. */
export interface IKartverketAddress {
    Street?: string;
    ZipCode?: string;
    City?: string;
}

/** Maps a SearchAddress OData response into a typed address suggestion. */
export class KartverketAddressExtensionClass implements IKartverketAddress {
    // @ts-ignore Retail proxy generated entity properties are initialized by the constructor.
    public Street: string;

    // @ts-ignore Retail proxy generated entity properties are initialized by the constructor.
    public ZipCode: string;

    // @ts-ignore Retail proxy generated entity properties are initialized by the constructor.
    public City: string;

    constructor(odataObject?: any) {
        odataObject = odataObject || {};
        this.Street = odataObject.Street;
        this.ZipCode = odataObject.ZipCode;
        this.City = odataObject.City;
    }
}
